import styled from 'styled-components';

import {
  ColumnBlock,
  HorizontalCenterColumnBlock,
  VerticalHorizontalCenterBlock
} from '../../../styled';

export const DivWithHeight = styled(VerticalHorizontalCenterBlock)<{ height: number }>`
  height: 100%;
  width: 100%;
  min-height: ${(props) => props.height}px;
  border-radius: 8px;
  transition: min-height 300ms ease-out;
`;

export const ResultWrapper = styled.div`
  padding: 64px 32px 46px;
`;

export const ResultTitleWrapper = styled(HorizontalCenterColumnBlock)`
  gap: 12px;
`;

export const Title = styled.p`
  ${(props) => props.theme.typography.title2};
  line-height: 26px;
  text-align: center;
`;

export const FooterWrapper = styled(ColumnBlock)`
  margin-top: 64px;
  gap: 24px;
`;

export const Subtitle = styled.p`
  ${(props) => props.theme.typography.subHeader2};
`;
